import { useTranslation } from 'next-i18next';
import type { OpeningHoursType } from '../../../types';
import type { HourFormatType } from './getFormattedTime';
import { getFormattedTime } from './getFormattedTime';

export type FormattedScheduleType = {
  startDay: string;
  endDay?: string;
  openingTime: string | null;
  closingTime: string | null;
};

const WEEK_DAYS = new Map([
  [1, 'monday'],
  [2, 'tuesday'],
  [3, 'wednesday'],
  [4, 'thursday'],
  [5, 'friday'],
  [6, 'saturday'],
  [0, 'sunday'],
]);

export const useFormattedSchedule = (
  openingHours: OpeningHoursType[],
  shouldGroup: boolean,
  hourFormat: HourFormatType = 'h',
) => {
  const { t } = useTranslation('lib-global-common');
  const formattedSchedule: FormattedScheduleType[] = [];

  WEEK_DAYS.forEach((weekDayName) => {
    const daySchedule = openingHours?.find((element) => weekDayName.toUpperCase() === element.day);
    // daySchedule format always comes back in 24-hour type and hh format
    const openingTime = daySchedule ? getFormattedTime(daySchedule.openingTime, hourFormat) : null;
    const closingTime = daySchedule ? getFormattedTime(daySchedule.closingTime, hourFormat) : null;

    if (
      shouldGroup &&
      formattedSchedule.length !== 0 &&
      formattedSchedule[formattedSchedule.length - 1].openingTime === openingTime &&
      formattedSchedule[formattedSchedule.length - 1].closingTime === closingTime
    )
      formattedSchedule[formattedSchedule.length - 1].endDay = t(`week.day.${weekDayName}`);
    else formattedSchedule.push({ startDay: t(`week.day.${weekDayName}`), openingTime, closingTime });
  });
  return formattedSchedule;
};
